import request from '@/utils/http';

/* 注册信息 - S */

// 开票注册
export const getInvoiceRegUrl = (params) => {
    return request({
        url: `/api-bms-web/eis/getInvoiceRegUrl`,
        method: 'get',
        params
    });
};

// 查询-
export const queryInvoiceRegInfo = (data) => {
    return request({
        url: `/api-bms-web/eis/queryInvoiceRegInfo`,
        method: 'post',
        data
    });
};

// 启停状态变更
export const changeEnableStatus = (data) => {
    return request({
        url: `/api-bms-web/eis/changeEnableStatus`,
        method: 'post',
        data
    });
};

/* 注册信息 - E */

/* 商品信息 - S */

// 查询
export const queryProductInfo = (data) => {
    return request({
        url: `/api-bms-web/eis/queryProductInfo`,
        method: 'post',
        data
    });
};

// 保存
export const saveProductInfo = (data) => {
    return request({
        url: `/api-bms-web/eis/saveProductInfo`,
        method: 'post',
        data
    });
};

// 删除
export const delProductInfo = (data) => {
    return request({
        url: `/api-bms-web/eis/delProductInfo`,
        method: 'post',
        data
    });
};

// 查询税收分类信息
export const queryTaxClassInfo = (data) => {
    return request({
        url: `/api-bms-web/eis/queryTaxClassInfo`,
        method: 'post',
        data
    });
};

/* 商品信息 - E */
